import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/vercel/path1/app/landing-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/next/dist/client/app-dir/link.js");
